
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28.17 24l6.254-6.254a1.966 1.966 0 000-2.78l-1.39-1.39a1.966 1.966 0 00-2.78 0L24 19.83l-6.254-6.254a1.966 1.966 0 00-2.78 0l-1.39 1.39a1.966 1.966 0 000 2.78L19.83 24l-6.254 6.254a1.966 1.966 0 000 2.78l1.39 1.39a1.966 1.966 0 002.78 0L24 28.17l6.254 6.254a1.966 1.966 0 002.78 0l1.39-1.39a1.966 1.966 0 000-2.78L28.17 24z","fill":"#535353","fill-rule":"nonzero"}})])
          )
        }
      }
    